// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1YFjQ","footer":"ModalInfo_footer__3u-4f"};